import { z } from 'zod';
import { normaliseMileage } from '@/features/vehiclesearch/utils/mileage';
import { invoiceNumberField, mileageField } from './invoiceSubmit.schema';
import type { ThirdPartyInvoiceRequest } from '../types/thirdPartyAgreement.types';

export const thirdPartyInvoiceSchema = z.object({
    invoiceNumber: invoiceNumberField,
    mileage: mileageField,
});

export type ThirdPartyInvoiceValues = z.infer<typeof thirdPartyInvoiceSchema>;

export const THIRD_PARTY_INVOICE_DEFAULTS: ThirdPartyInvoiceValues = { invoiceNumber: '', mileage: '' };

export const toThirdPartyInvoiceRequest = (
    values: ThirdPartyInvoiceValues,
    contentId: number,
    encryptedDealerId: string,
): ThirdPartyInvoiceRequest => ({
    contentId,
    encryptedDealerId,
    invoiceNumber: values.invoiceNumber,
    mileage: Number(normaliseMileage(values.mileage)),
});
